import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { VictoryPie } from 'victory';

import Circle from '../../../components/gfx/Circle';

class SexStats extends PureComponent {
    colorPicker(idx) {
        if (idx === 0) {
            return '#0063fb'; // secondary-blue
        } else {
            return '#06BEFB'; // toothpaste
        }
    }

    render() {
        const pieData = [
            { x: 'Mann', y: this.props.male },
            { x: 'Kvinne', y: this.props.female },
        ];

        return (
            <div className="panel">
                <h3 className="u-screen-reader-only">Kjønn</h3>
                <div className="u-text-center">
                    <VictoryPie
                        colorScale={['#0063fb', '#06BEFB']}
                        data={pieData}
                        innerRadius={40}
                        labels={[]}
                    />
                </div>
                <div className="u-mt16">
                    <table className="data-table">
                        <tbody>
                            <tr>
                                <td width="20">
                                    <Circle
                                        color="u-bg-primary-blue"
                                        size="20px"
                                    />
                                </td>
                                <td>Mann</td>
                                <td className="u-text-right">
                                    {this.props.malePercent}%
                                </td>
                            </tr>
                            <tr>
                                <td width="20">
                                    <Circle
                                        color="u-bg-secondary-blue"
                                        size="20px"
                                    />
                                </td>
                                <td>Kvinne</td>
                                <td className="u-text-right">
                                    {this.props.femalePercent}%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
SexStats.propTypes = {
    male: PropTypes.number.isRequired,
    female: PropTypes.number.isRequired,
    malePercent: PropTypes.number.isRequired,
    femalePercent: PropTypes.number.isRequired,
};

export default SexStats;
